export const TASK = 'TASK' as const;
export const EPIC = 'EPIC' as const;
export type HierarchyParent = typeof EPIC | typeof TASK;
